import { render, staticRenderFns } from "./FormatDisplay.vue?vue&type=template&id=377e3b95&scoped=true"
import script from "./FormatDisplay.vue?vue&type=script&lang=js"
export * from "./FormatDisplay.vue?vue&type=script&lang=js"
import style0 from "./FormatDisplay.vue?vue&type=style&index=0&id=377e3b95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e3b95",
  null
  
)

export default component.exports